<script setup lang="ts">
import AnchorLinkFlat from 'theme/components/atoms/AnchorLinkFlat.vue';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';
import { computed } from 'vue';
import { useIsInIframe } from '~/components/templates/_lp/PartnerPontaTemplate/composables/useIsInIframe';
import { CHANNEL_ID_MAP } from '~/entity/channel';

const PLANNER_ID = 2757;
const {
  public: { appOrigin },
} = useRuntimeConfig();
const path = `/register?redirect=%2Fplanner%2F${PLANNER_ID}%2Fmatching&inflow_channel=${CHANNEL_ID_MAP.PONTA}&exclusive`;
const to = { path };
const href = `${appOrigin}${path}`;
const { isInIframe } = useIsInIframe();
const linkComponent = computed(() => {
  return isInIframe ? AnchorLinkFlat : NuxtLinkFlat;
});
const target = computed((): string => {
  return isInIframe ? '_blank' : '_self';
});
const rel = computed(() => {
  return isInIframe ? 'noopener' : undefined;
});
</script>

<template>
  <div :class="$style.wrapper">
    <component
      :is="linkComponent"
      :class="$style.cvButton"
      :to="to"
      :href="href"
      :target="target"
      :rel="rel"
      variant="conversion"
      ><span :class="$style.cvButton__label">無料</span
      >チャットを始める</component
    >
  </div>
</template>

<style lang="scss" module>
.wrapper {
  background-color: #fde055;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cvButton {
  $root: &;

  display: inline-flex;
  align-items: center;
  font-size: 22px;
  padding: 0.5em 1.5em 0.55em;
  margin: 24px;
  border-radius: 16px;
  width: 100%;

  @include small-mobile-only {
    font-size: 18px;
  }

  @include tablet-upper {
    font-size: 28px;
  }

  &__label {
    padding: 6px 12px 5px;
    margin-right: 10px;
    color: $color-text-and-object-accent-orange;
    background-color: $color-surface-primary;
    border-radius: 9999em;
    font-size: 16px;
    line-height: 1;
    text-align: center;
    letter-spacing: 0.2em;
    text-indent: 0.2em;
  }
}
</style>
